export default __webpack_public_path__ + "static/media/KZ.T.06.Е1246.86a82193.svg";